import React, { Component, CSSProperties } from "react";
// import { ProgressSpinner } from "primereact/progressspinner";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./UILoader.scss";

export type UILoaderProps = { display: boolean; className?: string; loaderStyle?: CSSProperties };

const UILoaderFire: React.FC<UILoaderProps> = (props: UILoaderProps) => {
	// const [open, setOpen] = useState(true);
	if (!props.display) return null;

	return (
		<>
			<div className="fire">
				<div className="flames">
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
				</div>
				{/* <div className="logs"></div> */}
			</div>
			{/* <div className="fire">
				<div className="flames">
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
				</div>
			</div>
			<div className="fire">
				<div className="flames">
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
					<div className="flame"></div>
				</div>
			</div> */}
		</>
	);
};

class UILoader extends Component<UILoaderProps> {
	private display: boolean = false;
	private _isMounted: boolean = false;

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	render() {
		if (!this.props.display) return null;
		return (
			// <ProgressSpinner
			// 	className={this.props.display ? "" : "d-none " + (this.props.className || "")}
			// 	animationDuration="1"
			// />
			// <CircularProgress color="primary" />
			<div className={this.props.className} style={{ width: "100%", height: "100%", textAlign: "center" }}>
				<CircularProgress style={this.props.loaderStyle || { margin: "20vh auto" }} />
			</div>
		);
	}
}

export default UILoader;
